import React from 'react';
import { RichText } from '../RichText';
const deliverySteps = [{
  title: 'Choose a product',
  text: "Open the product's sales page to see full details and pricing."
}, {
  title: 'Complete checkout',
  text: 'Pay securely by card through the checkout on the sales page.'
}, {
  title: 'Receive it instantly',
  text: 'As soon as your payment is approved, your product is sent immediately to the email address you used at checkout.'
}];
export function DeliverySection() {
  return <section id="delivery" aria-labelledby="delivery-heading" className="scroll-mt-16 bg-canvas" data-id="element-99" data-mp="1vjb1gbgxqoh3">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 md:py-20" data-id="element-100" data-mp="1hk1kh9kwnqc2">
        <h2 id="delivery-heading" className="font-serif text-3xl font-semibold tracking-tight text-ink" data-id="element-101" data-mp="1hluumyuq8sot">From purchase to access</h2>
        <p className="mt-3 max-w-2xl text-muted" data-id="element-102" data-mp="3bx9itb83ak2g">All products are digital. Nothing is shipped, and no shipping fees apply.</p>
        <ol className="mt-10 grid gap-8 md:grid-cols-3" data-id="element-103" data-mp="3gvuklf2zpbt0">
          {deliverySteps.map((step, i) => <li key={step.title} className="border-t-2 border-ink pt-5" data-id="element-104" data-mp="3oszsld3z2hes" data-mpi={i}>
              <span className="font-serif text-sm font-semibold text-accent" data-id="element-105" data-mp="3kt8wctvof92v">Step {i + 1}</span>
              <h3 className="mt-2 text-lg font-semibold text-ink" data-id="element-106" data-mp="2f9bzrvzaheb">{step.title}</h3>
              <p className="mt-2 leading-relaxed text-muted" data-id="element-107" data-mp="3tl14gxx8a64a"><RichText text={step.text} data-id="element-108" data-mp="3tmc2si7wmlo0" /></p>
            </li>)}
        </ol>
      </div>
    </section>;
}